import React from "react";
import { BrowserRouter } from "react-router-dom";
import RouteHandler from "./Routes";

const App = () => {
    return (
        <BrowserRouter>
            <RouteHandler />
        </BrowserRouter>
    );
};

export default App;
